import { MerchantId, SetHeaderService } from "@/helper/userHelper";
import { EmployeeModel } from "@/model/employee/employeeModel";
import { EmployeeTableHistoryViewModel } from "@/model/employee/employeeTableHistoryViewModel";
import { EmployeeTableViewModel } from "@/model/employee/employeeTableViewModel";
import { EmployeeTotalYearlyByEmployeeIdList } from "@/model/employee/employeeTotalYearlyByEmployeeIdList";
import service from "../baseHttpService";

class EmployeeService {
  DoCreateEmployee(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: {
        employee: input.employee,
        image: input.image,
        fileEmployeeIDCard: input.fileEmployeeIDCard,
        fileEmployeeContract: input.fileEmployeeContract,
        confirmationEmailOrBankNumber: input.confirmationEmailOrBankNumber,
      },
    };

    return service.peakPayrollAPI.post("/api/Employee/CreateEmployee", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoImportEmployee(employeeList: any) {
    const _input = {
      merchantId: MerchantId(),
      data: employeeList,
    };

    return service.peakPayrollAPI.post("/api/Employee/ImportEmployee", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoUpdateEmployee(employe: EmployeeModel) {
    const _input = {
      merchantId: MerchantId(),
      data: employe,
    };
    return service.peakPayrollAPI.post("/api/Employee/UpdateEmployee", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetEmployeeList() {
    const _input = {
      merchantId: MerchantId(),
    };
    return service.peakPayrollAPI.post("/api/Employee/GetEmployeeList", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetEmployeeListByPasscode(merchantId: number) {
    const _input = {
      merchantId: merchantId,
    };
    return service.peakPayrollAPI
      .post("/api/Employee/GetEmployeeListPasscode", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }

  DoGetEmployeeTable(employeeTableViewModel: EmployeeTableViewModel) {
    const _input = {
      merchantId: MerchantId(),
      data: employeeTableViewModel,
    };

    return service.peakPayrollAPI.post("/api/Employee/GetEmployeeTable", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoUpdateEmployeeDeleted(employeeId: number) {
    const _input = {
      merchantId: MerchantId(),
      data: employeeId,
    };
    return service.peakPayrollAPI
      .post("/api/Employee/UpdateEmployeeDeleted", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }

  DoGetEmployeeDetail(employeeId: number) {
    const _input = {
      merchantId: MerchantId(),
      data: employeeId,
    };

    return service.peakPayrollAPI.post("/api/Employee/GetEmployeeDetail", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetEmployeeSuggestionCode(departmentId: number) {
    const _input = {
      merchantId: MerchantId(),
      data: departmentId,
    };
    return service.peakPayrollAPI
      .post("/api/Employee/GetEmployeeSuggestionCode", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }

  DoUploadImageEmployee(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: {
        employeeId: input.employeeId,
        image: input.image,
        fileEmployeeIDCard: input.fileEmployeeIDCard,
        fileEmployeeContract: input.fileEmployeeContract,
      },
    };
    return service.peakPayrollAPI.post("/api/Employee/UploadImageEmployee", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }

  DoDeleteImageEmployee(employeeId: number) {
    const _input = {
      merchantId: MerchantId(),
      data: employeeId,
    };
    return service.peakPayrollAPI.post("/api/Employee/DeleteImageEmployee", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetEmployeeFinanceChanelDetailList(employeeIdList: Array<number>) {
    const _input = {
      merchantId: MerchantId(),
      data: employeeIdList,
    };
    return service.peakPayrollAPI
      .post("/api/Employee/GetEmployeeFinanceChanelDetailList", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetEmployeeStatementDetailList(employeeIdList: Array<number>) {
    const _input = {
      merchantId: MerchantId(),
      data: employeeIdList,
    };
    return service.peakPayrollAPI
      .post("/api/Employee/GetEmployeeStatementDetailList", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoUpdateEmployeeResign(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: {
        employeeId: input.employeeId,
        isResign: input.isResign,
        employeeEndDate: input.employeeEndDate,
        employeeResignReason: input.employeeResignReason,
        employeeResignNote: input.employeeResignNote,
      },
    };
    return service.peakPayrollAPI.post("/api/Employee/UpdateEmployeeResign", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetEmployeeHistoryDetail(employeeTableHistoryViewModel: EmployeeTableHistoryViewModel) {
    const _input = {
      merchantId: MerchantId(),
      data: {
        employeeId: employeeTableHistoryViewModel.employeeId,
        year: employeeTableHistoryViewModel.year,
        pageNo: employeeTableHistoryViewModel.pageNo,
        pageSize: employeeTableHistoryViewModel.pageSize,
        orderType: employeeTableHistoryViewModel.sortBy,
        sortingType: employeeTableHistoryViewModel.sortType,
      },
    };
    return service.peakPayrollAPI
      .post("/api/Employee/GetEmployeeDetailSalaryHistory", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetSalaryEmployeeTotalYearlyByEmployeeIdList(input: EmployeeTotalYearlyByEmployeeIdList) {
    const _input = {
      merchantId: MerchantId(),
      data: {
        employeeIdList: input.employeeIdList,
        toDate: input.toDate,
        fromDate: input.fromDate,
        salaryId: input.salaryId,
      },
    };
    return service.peakPayrollAPI
      .post("/api/Employee/GetSalaryEmployeeTotalYearlyByEmployeeIdList", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
}

export default new EmployeeService();
